// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    baseListingPageFormSchema,
    BaseListingPageValuesType,
    baseListingPageInitialValues,
} from "./_formTypes";
import {
    useGetIPRestrictionList,
    useDeleteIPRestriction,
    useCreateIPRestriction,
    useUpdateIPRestriction,
    IIPRestriction,
    IIPRestrictionListRequest,
} from "../../../hooks/ipRestriction";
import { useGetAllMerchantList } from "../../../hooks/merchant";
import {
    // useGetEntityList,
    // useDeleteEntity,
    // useCreateEntity,
    // useUpdateEntity,
    PagingResponse,
    useAuthorization,
} from "../../../hooks";
import {
    GridColDef,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState, forwardRef, useImperativeHandle } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    FormControl,
    Link,
    Box,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
    Button as MaterialButton
} from "@mui/material";
import { Button, Loading, MerchantSelector } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
    DateTimePickerControl,
    InputControl,
    Table,
    DeleteConfirmModal,
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useUserInfo } from "../../../store/User.state";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { IPControlModal, IpControlFormValues } from "./IPControlModal";

export const IPControlListingTable = forwardRef(({ type }: { type: number }, ref) => {
    const theme = useTheme();
    const { showDelete, showUpdate } = useAuthorization();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [userInfo] = useUserInfo();
    const [queryOptions, setQueryOptions] = React.useState({});
    const { control, handleSubmit, setValue, getValues, reset } =
        useForm<BaseListingPageValuesType>({
            resolver: zodResolver(baseListingPageFormSchema),
            defaultValues: baseListingPageInitialValues,
        });
    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 25,
    });
    const [tableselectedRow, setTableSelectedRow] = useState({} as any);

    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState<any | undefined>(undefined);


    const {
        mutate: getIPRestrictionList,
        isLoading: isGetIPRestrictionListLoading,
    } = useGetIPRestrictionList();
    const {
        mutate: deleteIPRestriction,
        isLoading: isDeleteIPRestrictionLoading,
    } = useDeleteIPRestriction();
    const {
        mutate: createIPRestriction,
        isLoading: isCreateIPRestrictionLoading,
    } = useCreateIPRestriction();
    const {
        mutate: updateIPRestriction,
        isLoading: isUpdateIPRestrictionLoading,
    } = useUpdateIPRestriction();

    const { data: allMerchantListResponse, isLoading: isAllMerchantListLoading } = useGetAllMerchantList("ACTIVE"); // New hook call

    const merchantList = useMemo(() => { // New useMemo for merchantList
        if (allMerchantListResponse && allMerchantListResponse.data) {
            return allMerchantListResponse.data.map((merchant: any) => ({
                label: merchant.merchantName + ` (${merchant.merchantId})`,
                value: merchant.merchantId,
                option: merchant.merchantName + ` (${merchant.merchantId})`
            }));
        }
        return [];
    }, [allMerchantListResponse]);


    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
    const [showTable, setShowTable] = useState(false)
    const setSnackbar = useSetSnackBar();



    useEffect(() => {
        reset(baseListingPageInitialValues);
    }, [type, reset]);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    useEffect(() => {
        const savedFilter = localStorage.getItem("ipControlListingPageFilter");
        if (savedFilter) {
            setQueryOptions(JSON.parse(savedFilter));
        }
    }, []);

    const [formValues, setFormValues] = useState<any | null>(null);
    const [isSubmitted, setIsSubmitted] = useState(false)
    const onSubmit = (data: BaseListingPageValuesType) => {
        setPaginationModel({
            page: 0,
            pageSize: paginationModel.pageSize
        });
        setFilterAccordionExpand(false);
        setTableData(undefined);
        setShowTable(true)
        const req: IIPRestrictionListRequest = {
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            filters: []
        };

        if (type) {
            req.filters?.push({
                field: "type",
                values: [type.toString()],
                operationType: 6, // Equals
                valueType: 2 // Integer
            });
        }

        if (data.merchantId && data.merchantId.length > 0) {
            req.filters?.push({
                field: "merchantId",
                values: data.merchantId.map((id) => id.toString()),
                operationType: RequestFilterOperationTypeEnum.EQUALS,
                valueType: RequestFilterValueTypeEnums.NUMBER
            });
        }


        if (data.searchText) {
            req.filters?.push({
                field: "ipAddress", // Use 'ip' field for search
                values: [data.searchText],
                operationType: RequestFilterOperationTypeEnum.EQUALS, // Equals
                valueType: RequestFilterValueTypeEnums.STRING // String
            });
        }

        setFormValues(req);
        setIsSubmitted(true);
    };

    useEffect(() => {
        if (!isSubmitted || !formValues) {
            return;
        }
        refreshData();
    }, [formValues, isSubmitted, queryOptions, paginationModel]);

    function refreshData() {
        const requestPayload = {
            ...formValues,
            ...getQueryParams(queryOptions),
            size: paginationModel.pageSize,
            page: paginationModel.page,
        };

        // if (requestPayload.filters) {
        //     requestPayload.filters = [
        //         ...requestPayload.filters,
        //         ...dynamicFilters
        //     ]
        // }

        getIPRestrictionList(requestPayload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setTableData(data.data);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setTableData(undefined);
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });
    }

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const deleteRow = React.useCallback(
        (row: any) => () => {
            setTableSelectedRow(row);
            setIsDeleteModalOpen(true);
        },
        []
    );

    const handleDeleteConfirm = () => {
        const req = {
            id: tableselectedRow?.id,
        };
        deleteIPRestriction(req, {
            onSuccess: (data: any) => {
                if (data.isSuccess) {
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                    refreshData();
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });

        handleCloseDeleteModal();
    };

    // Modal Handlers
    useImperativeHandle(ref, () => ({
        openModal: (data?: any) => {
            handleModalOpen(data);
        }
    }));

    const handleModalOpen = (data?: any) => {
        setModalData(data);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setModalData(undefined);
    };

    const handleModalSave = (data: IpControlFormValues) => {
        const mutationOptions = {
            onSuccess: (data: any) => {
                if (data.isSuccess) {
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                    refreshData();
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        };

        if (modalData?.id) { // Edit mode
            updateIPRestriction({ ...data, id: modalData.id }, mutationOptions);
        } else { // Add mode
            createIPRestriction(data, mutationOptions);
        }
        handleModalClose();
    };


    const columns: GridColDef[] = useMemo(() => {
        const baseColumns: GridColDef[] = [
            {
                field: "Aksiyonlar",
                type: "actions",
                width: 80,
                getActions: (params) => [
                    !!showUpdate ? (
                        <GridActionsCellItem
                            label="Düzenle"
                            onClick={() => handleModalOpen(params.row)}
                            showInMenu
                        />
                    ) : (<></>),
                    !!showDelete ? (
                        <GridActionsCellItem
                            label="Sil"
                            onClick={deleteRow(params.row)}
                            showInMenu
                        />
                    ) : (
                        <></>
                    ),
                ],
            },
            { field: "ipAddress", headerName: "IP Adresi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
            { field: "description", headerName: "Açıklama", width: 300, columnType: RequestFilterValueTypeEnums.STRING },
        ];

        if (type === 2) { // Only for whitelist tab
            baseColumns.push({ field: "merchantId", headerName: "Üye İşyeri No.", width: 250, columnType: RequestFilterValueTypeEnums.STRING });
            baseColumns.push({ field: "merchantName", headerName: "Üye İşyeri Adı", width: 250, columnType: RequestFilterValueTypeEnums.STRING });
        }

        const commonColumns: GridColDef[] = [
            {
                field: "createDate", headerName: "Oluşturma Tarihi", width: 200,
                columnType: RequestFilterValueTypeEnums.DATE,
                renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm:ss");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                }
            },
            { field: "createFullName", headerName: "Oluşturan Kullanıcı", width: 300, columnType: RequestFilterValueTypeEnums.STRING },
        ];

        return [...baseColumns, ...commonColumns];
    }, [deleteRow, showDelete, showUpdate, type]);

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
        setTableData(undefined);
    };

    const onSave = () => {
        setSnackbar({
            severity: "info",
            isOpen: true,
            description: "Excel'e aktarma işlemi entegre edilecek.",
        });
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const getQueryParams = (filters) => {
        const queryParams = {};
        for (let key in filters) {
            let value = filters[key];
            if (value !== null && value !== undefined && value.toString().length > 0) {
                queryParams[key] = value;
            }
        }
        return queryParams;
    };

    const convertTableFiltersToRequestFilter = (tableFilters) => {
        let convertedFilters = [];
        if (tableFilters?.items) {
            tableFilters.items.map((item) => {
                var findColumn = columns.find(x => x.field == item.field);
                if (findColumn && item.value !== undefined && item.value !== null) {
                    convertedFilters.push({
                        field: item.field,
                        values: [item.value.toString()],
                        valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn.columnType),
                        operationType: mapReactMUIToFilterOperationTypes(item.operator)
                    });
                }
            });
        }
        return convertedFilters;
    }

    const [dynamicFilters, setDynamicFilter] = useState([]);

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            localStorage.removeItem('ipControlListingPageFilter')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        // A simple validation to prevent too many requests with short filter text
        const allValuesValid = Object.values(queryParams).every((value) => value.toString().length >= 3);

        if (allValuesValid || currentKeysLength < previousKeysLength) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
            localStorage.setItem('ipControlListingPageFilter', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;

    }, 500);

    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    const previousQueryParams = React.useRef({});
    const hasLoading = isGetIPRestrictionListLoading || isDeleteIPRestrictionLoading || isCreateIPRestrictionLoading || isUpdateIPRestrictionLoading || isAllMerchantListLoading;

    return (
        <>
            {hasLoading && <Loading />}
            <Stack flex={1} justifyContent="space-between">
                <Stack flex={1} p={2}>
                    <BaseFilterTableWithAccordion summary="Filtre" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
                        child={<Stack spacing={4}>
                            <Stack
                                spacing={3}
                                direction={isDesktop ? "row" : "column"}
                                width={isDesktop ? "100%" : "auto"}
                                maxWidth={1308}
                            >
                                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                    <InputControl
                                        label="Arama"
                                        control={control}
                                        id="searchText"
                                    />
                                </FormControl>
                                {type === 2 && (
                                    <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                        <Controller
                                            name="merchantId"
                                            control={control}
                                            render={({ field }) => (
                                                <MerchantSelector
                                                    field={field}
                                                    merchantList={merchantList}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                )}
                                <div style={{ flex: 1 }} />
                            </Stack>

                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                width={isDesktop ? "100%" : "auto"}
                                maxWidth={1308}
                            >
                                <Button
                                    onClick={handleSubmit(onSubmit)}
                                    variant="contained"
                                    text={"ARA"}
                                />
                            </Stack>
                        </Stack>} />
                    <Stack flex={1} mt={2}  >
                        {showTable && (
                            <>
                                <Table
                                    filterKey="ipControlListingPageFilter"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    getRowId={(row) => row.ipAddress}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={handleChangePagination}
                                    paginationMode="server"
                                    rowCount={tableData?.totalItems || 0}
                                    isRowSelectable={() => false}
                                    rows={tableData?.result || []}
                                    customLabelDisplayedRows={true}
                                    autoHeight={false}
                                    columns={columns}
                                    exportFileName="Liste"
                                    onSave={null}
                                />
                                <DeleteConfirmModal
                                    isOpen={isDeleteModalOpen}
                                    onClose={handleCloseDeleteModal}
                                    title="Silme Onayı"
                                    content="Seçili kaydı silmek istiyor musunuz?"
                                    confirmButtonText="Evet"
                                    closeButtonText="Hayır"
                                    onConfirm={handleDeleteConfirm}
                                ></DeleteConfirmModal>
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
            <IPControlModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onSave={handleModalSave}
                initialData={modalData}
                merchantList={merchantList}
            />
        </>
    );
});
